import { useContext } from "react";
import { BdcContext } from "../context/bdcContext";

const useBdcContext = () => {
  return useContext(BdcContext);
};

export default useBdcContext;
